import http from '../Http';
import { DATA_ENDPOINTS, PROFILE_ENDPOINTS, SUBMIT_ENDPOINTS } from '../constants/Endpoints';

class TeacherUtil {
  static getTeachers(config = {}) {
    return http.get(DATA_ENDPOINTS.TABLE.TEACHERS, config);
  }

  static getCurrentTeacher() {
    return http.get(PROFILE_ENDPOINTS.EMPLOYEE);
  }

  static updateTeacher(id, data) {
    return http.put(SUBMIT_ENDPOINTS.TEACHERS.UPDATE.replace('{id}', id), data);
  }
}

export default TeacherUtil;
